import { ClientInferResponseBody } from "@ts-rest/core";

import { api, contract } from "#app/http/api";
import { ApiError } from "#shared/infra/apiError";
import { MaterialUploadResponse } from "shared";

type uploadCustomMaterialsResponse = ClientInferResponseBody<
  typeof contract.materials.uploadCustomMaterials,
  200
>;

export const uploadCustomMaterials = async (file: File): Promise<uploadCustomMaterialsResponse> => {
  const formData = new FormData();
  formData.append("file", file);

  const response = await api.materials.uploadCustomMaterials.mutation({
    body: formData,
  });

  if (response.status === 200) {
    return response.body;
  }

  if (response.status === 400) {
    const errorResponse = response.body as MaterialUploadResponse;
    throw errorResponse;
  }

  throw new ApiError("Failed to import materials", response.status, response.body);
};
